import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onDrop"]
const _hoisted_2 = { class: "flex flex-col items-center" }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center justify-center flex-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]

import { ref } from 'vue'
import { PhotographIcon, XIcon } from '@heroicons/vue/outline'


export default /*#__PURE__*/_defineComponent({
  __name: 'Upload',
  emits: ['uploaded'],
  setup(__props, { emit }) {



const fileUpload = ref()
const imgSrc = ref<any>([])

const onRemove = (index: number) => {
  imgSrc.value.splice(index, 1)
}
const onClickUpload = () => {
  fileUpload.value.click()
}
const readFile = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      imgSrc.value.push({ file, value: e.target!.result })
      resolve('')
    }
    reader.readAsDataURL(file)
  })
const onUpload = async (event: any) => {
  const files: any = event.target.files
  for (const file of [...files]) {
    await readFile(file)
  }

  const dataTransfer = new DataTransfer()
  imgSrc.value.forEach(({ file }: any) => dataTransfer.items.add(file))
  fileUpload.value.files = dataTransfer.files
}
const onDrop = async (event: DragEvent) => {
  event.preventDefault()
  const files = event.dataTransfer!.files
  for (const file of files) {
    await readFile(file)
  }

  const dataTransfer = new DataTransfer()
  imgSrc.value.forEach(({ file }: any) => dataTransfer.items.add(file))
  fileUpload.value.files = dataTransfer.files
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.pictureReferFromOper')) + " ", 1),
    _createElementVNode("label", {
      class: "items-center w-full min-h-10 rounded-md p-3",
      onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers(onDrop, ["prevent"])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "w-full flex flex-col justify-center items-center border-2 border-solid p-4",
        style: {"height":"160px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickUpload()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(PhotographIcon), { class: "w-6 h-6" }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('messages.ticketManagement.upload')), 1)
        ]),
        _createElementVNode("input", {
          hidden: "",
          multiple: "",
          type: "file",
          accept: "image/*,video/*",
          ref_key: "fileUpload",
          ref: fileUpload,
          name: "attachments",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (onUpload($event)))
        }, null, 544)
      ])
    ], 40, _hoisted_1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgSrc.value, (img, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "relative flex justify-end"
        }, [
          _createElementVNode("div", {
            class: "absolute w-5 h-5 flex items-center justify-center bg-red-600 rounded-full p-1 cursor-pointer",
            style: {"z-index":"100"},
            onClick: ($event: any) => (onRemove(index))
          }, [
            _createVNode(_unref(XIcon), { class: "text-white" })
          ], 8, _hoisted_4),
          (img.value.startsWith('data:image'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("img", {
                  src: img.value,
                  style: {"width":"140px","height":"140px"}
                }, null, 8, _hoisted_6)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createElementVNode("video", {
                  src: img.value,
                  style: {"width":"140px","height":"140px"},
                  controls: ""
                }, " Your browser does not support the video tag. ", 8, _hoisted_8)
              ]))
        ]))
      }), 128))
    ])
  ]))
}
}

})